import { Link, useLocation, Outlet } from 'react-router-dom';
import { User, CreditCard, ArrowLeft } from 'lucide-react';

const SettingsLayout = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/settings/profile', icon: User, label: 'Profile' },
    { path: '/settings/plans', icon: CreditCard, label: 'Plans & Credits' },
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A] flex">
      {/* Left Sidebar */}
      <div className="w-64 h-screen fixed left-0 top-0 bg-white border-r border-[#E2E8F0] flex flex-col">
        <div className="p-6 border-b border-[#E2E8F0]">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 text-[#475569] hover:text-[#2563EB] transition-colors text-sm font-semibold"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Link>
        </div>

        <div className="px-4 pt-6">
          <div className="text-xs font-bold text-[#94A3B8] uppercase tracking-widest mb-4 px-3">Settings</div>
          <div className="space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all ${
                    isActive
                      ? 'bg-[#EFF6FF] text-[#2563EB]'
                      : 'text-[#475569] hover:bg-[#F8FAFC] hover:text-[#0F172A]'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="text-sm font-semibold">{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 ml-64 p-8 relative z-10">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;
